/**
 * Authors page container component.
 *
 * Displays a list of all registered users/members on the platform.
 * Fetches author data from the backend and provides search/filtering capabilities
 * via the SearchFilterBar component. Shows user information in a card layout.
 *
 * @module containers/Authors
 * @category Containers
 * @param {Object} props
 * @param {Array} props.initialAuthors - Optional preloaded authors data from route loader
 * @returns {React.ReactElement} Rendered authors page with member list
 */
import { useEffect, useState, useCallback, useRef } from "react";
import Breadcrumb from '../../components/Breadcrumb'
import CardBody from './CardBody'
import './AuthorsHeader.css'
import { getMainWidth, handelTitle } from "../../utils";
import chainData from "../../chains.js";
import { getAuthors } from "../../lib/api";
import SearchFilterBar from "../../components/SearchFilterBar";

const AuthorsContainer = ({ initialAuthors }) => {
    const [newListed, setNewListed] = useState(initialAuthors || []);

    const [spar, ssp] = useState("");
    const initialized = useRef(false);

    const fetchAuthors = useCallback((search) => {
        getAuthors({ sort: "lastActive", search: search || "" })
            .then(result => {
                const incoming = result.data || [];
                setNewListed(prev => {
                    // avoid loop: only update if data actually changed
                    if (prev.length === incoming.length && prev[0]?.id === incoming[0]?.id) return prev;
                    return incoming;
                });
            })
            .catch(err => {
                console.error('Failed to fetch authors:', err);
            });
    }, []);

    useEffect(() => {
        handelTitle('Users');
        getMainWidth();
    }, []);

    useEffect(() => {
        if (!initialAuthors && !initialized.current) {
            initialized.current = true;
            fetchAuthors("");
        }
    }, [initialAuthors, fetchAuthors]);

    useEffect(() => {
        fetchAuthors(spar || "");
    }, [spar, fetchAuthors]);

    // useEffect(() => {
    //     Backend('authors', { sort: "lastActive", search: spar})
    //         .then(data =>{
    //             setNewListed(data);
    //         })
    //
    //     getMainWidth();
    // }, [spar])

    return (
        <>
            <main className="main-content mt-1 border-radius-lg">

                <Breadcrumb text1='Our Members' text2={null}/>


                {/*        <div className="container-fluid">
          <SectionHeading
                          img={AuthorsIcon2}
                          text='Our Artists'
                          title='Our Artists'
                        />
        </div>*/}

                <div className="container-fluid">
                    <div className="col-12 py-4">
                        <div className="card-purple">
                            <div className="p-2 pt-42">
                                <SearchFilterBar
                                  searchValue={spar}
                                  onSearchChange={ssp}
                                  filterOptions={chainData}
                                  showFilter={false} // Network filter is present but commented out in original
                                />
                            </div>
                            <CardBody data={newListed}/>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default AuthorsContainer;
